/**
 * FooterBar用のContext
 * ページネーション情報などをグローバルに管理
 */

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PaginationInfo {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  totalItems: number;
  startItem: number;
  endItem: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (items: number) => void;
  itemsPerPageOptions?: number[];
}

interface FooterContextValue {
  pagination: PaginationInfo | null;
  setPagination: (pagination: PaginationInfo | null) => void;
  pageType: 'list' | 'detail' | 'form';
  setPageType: (type: 'list' | 'detail' | 'form') => void;
}

const FooterContext = createContext<FooterContextValue | undefined>(undefined);

export const FooterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [pagination, setPagination] = useState<PaginationInfo | null>(null);
  const [pageType, setPageType] = useState<'list' | 'detail' | 'form'>('detail');

  return (
    <FooterContext.Provider value={{ pagination, setPagination, pageType, setPageType }}>
      {children}
    </FooterContext.Provider>
  );
};

export const useFooter = () => {
  const context = useContext(FooterContext);
  if (!context) {
    throw new Error('useFooter must be used within FooterProvider');
  }
  return context;
};